var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isOpen
        ? _c(
            "v-btn",
            {
              staticClass: "text-none",
              class: {
                "mr-4 btn-text": _vm.$vuetify.breakpoint.mdAndUp,
                "mobile-btn-text": !_vm.$vuetify.breakpoint.mdAndUp
              },
              attrs: {
                color: "primary",
                depressed: "",
                light: "",
                dense: "",
                text: "",
                large: _vm.$vuetify.breakpoint.mdAndUp,
                rounded: ""
              },
              on: { click: _vm.onSigninClick }
            },
            [_vm._v("Đăng nhập")]
          )
        : _vm._e(),
      _vm.isOpen
        ? _c(
            "v-btn",
            {
              staticClass: "text-none white--text",
              class: {
                "mr-4 btn-text": _vm.$vuetify.breakpoint.mdAndUp,
                "mobile-btn-text": !_vm.$vuetify.breakpoint.mdAndUp
              },
              attrs: {
                color: "orange",
                elevation: "0",
                dense: "",
                rounded: "",
                large: _vm.$vuetify.breakpoint.mdAndUp
              },
              on: { click: _vm.onSignupClick }
            },
            [
              _vm._v(
                _vm._s(_vm.$vuetify.breakpoint.mdAndUp ? "Đăng ký" : "Đăng ký")
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }